// extracted by mini-css-extract-plugin
export default {"switchBox":"styles_switchBox__oUW12","switchBox_disabled":"styles_switchBox_disabled__AjJub"};